export const roles = {
  Admin: 'org_admin',
  TeamLead: 'team_lead',
  Member: 'team_member',
  SysAdmin: 'system_admin',
}
